import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Card } from 'react-bootstrap';
import { FiHome, FiSearch, FiArrowLeft } from 'react-icons/fi';
import { PrimaryButton, OutlinedPrimaryButton } from '../Components/Buttons';
import { useLanguage } from '../Context/LanguageContext';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{
      background: 'var(--gradient-light)',
      padding: '2rem 1rem'
    }}>
      <Container>
        <div className="row justify-content-center">
          <div className="col-12 col-md-8 col-lg-6">
            <Card className="border-0 shadow-lg bg-glass hover-shadow text-center">
              <Card.Body className="p-5">
                {/* Large 404 Number */}
                <div className="mb-4">
                  <h1 className="display-1 fw-bold text-primary-custom mb-3" style={{
                    fontSize: 'clamp(4rem, 15vw, 8rem)',
                    background: 'var(--gradient-primary)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text',
                    lineHeight: '1',
                    textShadow: '0 4px 8px rgba(118, 56, 177, 0.3)'
                  }}>
                    {t('pages.notfound.title')}
                  </h1>

                  {/* Decorative Line */}
                  <div
                    className="mx-auto mb-4"
                    style={{
                      width: '80px',
                      height: '4px',
                      background: 'var(--gradient-primary)',
                      borderRadius: '2px'
                    }}
                  ></div>
                </div>

                {/* Title */}
                <h2 className="h3 fw-bold text-primary-dark mb-3">
                  {t('pages.notfound.heading')}
                </h2>

                {/* Description */}
                <p className="text-muted mb-4 lead" style={{ lineHeight: '1.6' }}>
                  {t('pages.notfound.description')}
                </p>

                {/* Action Buttons */}
                <div className="d-flex flex-column flex-sm-row gap-3 justify-content-center mt-4">
                  <PrimaryButton
                    width="100%"
                    onClick={() => navigate('/')}
                    className="d-flex align-items-center justify-content-center gap-2"
                  >
                    <FiHome size={20} />
                    {t('pages.notfound.buttonHome')}
                  </PrimaryButton>

                  <OutlinedPrimaryButton
                    width="100%"
                    onClick={() => window.history.back()}
                    className="d-flex align-items-center justify-content-center gap-2"
                  >
                    <FiArrowLeft size={20} />
                    {t('pages.notfound.buttonBack')}
                  </OutlinedPrimaryButton>
                </div>

                {/* Help Text */}
                <div className="mt-4 pt-3">
                  <small className="text-muted d-flex align-items-center justify-content-center gap-2">
                    <FiSearch size={16} />
                    {t('pages.notfound.helpText')}
                  </small>
                </div>
              </Card.Body>
            </Card>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default NotFound; 